module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g538f"))).then(() => parcelRequire('d0iPb'));